import React from 'react';
import Layout from '../components/layout/Layout';
import EpicHero from '../components/home/EpicHero';
import ManifestoSection from '../components/home/ManifestoSection';
import MarqueeSection from '../components/home/MarqueeSection';
import HorizontalScroll from '../components/home/HorizontalScroll';
import BentoGrid from '../components/home/BentoGrid';
import ImageCurtain from '../components/home/ImageCurtain';

const HomePage = () => {
  return (
    <Layout transparentHeader>
      <EpicHero />
      <ManifestoSection />
      <MarqueeSection />
      <HorizontalScroll />
      <BentoGrid />
      <ImageCurtain />
    </Layout>
  );
};

export default HomePage;
